/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_ModeInputs */



/**
* | output |
* | --- |
* | "Way of practising" |
*
* @param {Practice_Session_ModeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mode = /** @type {((inputs?: Practice_Session_ModeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_ModeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Manier van oefenen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Façon de s'entraîner")
	return /** @type {LocalizedString} */ ("Way of practising")
});